import { useEffect, useState, useCallback } from "react";
import { Division, Trip } from "@/fetch/gworld";
import useResponsive from "./useResponsive";

const VolunteerOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const WorkingHolidayOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 12 }, // notification
  { id: "12", order: 12, mobileOrder: 1 }, // jobs
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const StudyOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const InternshipOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const SummerCampOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const TutorOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const TourOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const TeachOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const RemoteOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const SuperliteOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 13, mobileOrder: 13 }, // au pair/tutor profile
      { id: "1-6", order: 15, mobileOrder: 15 }, // trip details
      { id: "1-7", order: 14, mobileOrder: 14 }, // flight details
      { id: "1-8", order: 5, mobileOrder: 5 }, // jobs
      { id: "1-9", order: 12, mobileOrder: 12 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 16, mobileOrder: 16 }, // tours
      { id: "1-13", order: 9, mobileOrder: 9 }, // insurance
      { id: "1-14", order: 8, mobileOrder: 8 }, // visa
      { id: "1-15", order: 7, mobileOrder: 7 }, // resources
      { id: "1-16", order: 17, mobileOrder: 17 }, // donation
      { id: "1-17", order: 6, mobileOrder: 6 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 12 }, // notification
  { id: "12", order: 12, mobileOrder: 1 }, // jobs
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const AuPairOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 1 }, // notification
  {
    // account
    id: "6",
    order: 6,
    mobileOrder: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const GetawaysOrders = [
  {
    //experience
    id: "1",
    order: 1,
    mobileOrder: 3,
    children: [
      { id: "1-1", order: 1, mobileOrder: 1 }, // dashboard
      { id: "1-2", order: 2, mobileOrder: 2 }, // payments
      { id: "1-3", order: 3, mobileOrder: 3 }, // documents
      { id: "1-4", order: 4, mobileOrder: 4 }, // resume/cv
      { id: "1-5", order: 5, mobileOrder: 5 }, // au pair/tutor profile
      { id: "1-6", order: 6, mobileOrder: 6 }, // trip details
      { id: "1-7", order: 7, mobileOrder: 7 }, // flight details
      { id: "1-8", order: 8, mobileOrder: 8 }, // jobs
      { id: "1-9", order: 9, mobileOrder: 9 }, // arrival
      { id: "1-10", order: 10, mobileOrder: 10 }, // accommodation
      { id: "1-11", order: 11, mobileOrder: 11 }, // host family
      { id: "1-12", order: 12, mobileOrder: 12 }, // tours
      { id: "1-13", order: 13, mobileOrder: 13 }, // insurance
      { id: "1-14", order: 14, mobileOrder: 14 }, // visa
      { id: "1-15", order: 15, mobileOrder: 15 }, // resources
      { id: "1-16", order: 16, mobileOrder: 16 }, // donation
      { id: "1-17", order: 17, mobileOrder: 17 }, // upgrade
    ],
  },
  { id: "2", order: 2, mobileOrder: 5 }, // marketplace
  { id: "3", order: 3, mobileOrder: 4 }, // academy
  {
    // social
    id: "4",
    order: 4,
    mobileOrder: 2,
    children: [
      { id: "4-1", order: 1, mobileOrder: 1 }, // timeline
      { id: "4-2", order: 2, mobileOrder: 2 }, // profile
      { id: "4-3", order: 3, mobileOrder: 3 }, // messages
    ],
  },
  { id: "5", order: 5, mobileOrder: 12 }, // notification
  { id: "12", order: 12, mobileOrder: 1 }, // jobs
  {
    // account
    id: "6",
    order: 6,
    children: [
      { id: "6-1", order: 1, mobileOrder: 1 }, // profile
      { id: "6-2", order: 2, mobileOrder: 2 }, // contact
      { id: "6-3", order: 3, mobileOrder: 3 }, // personal
      { id: "6-7", order: 4, mobileOrder: 4 }, // personal
      { id: "6-4", order: 1, mobileOrder: 1 }, // visa
      { id: "6-5", order: 2, mobileOrder: 2 }, // settings
      { id: "6-6", order: 3, mobileOrder: 3 }, // about
    ],
  },
  { id: "7", order: 7, mobileOrder: 7 }, // setup
  { id: "8", order: 8, mobileOrder: 8 }, // finalise
  { id: "9", order: 9, mobileOrder: 9 }, // cancelation
  { id: "10", order: 10, mobileOrder: 10 }, // lock
  { id: "11", order: 11, mobileOrder: 11 }, // rewards
];

const DivisionMenuOrders = {
  [Division.AuPair]: AuPairOrders,
  [Division.Internship]: InternshipOrders,
  [Division.Remote]: RemoteOrders,
  [Division.Study]: StudyOrders,
  [Division.SummerCamp]: SummerCampOrders,
  [Division.Superlite]: SuperliteOrders,
  [Division.Teach]: TeachOrders,
  [Division.Tour]: TourOrders,
  [Division.Tutor]: TutorOrders,
  [Division.Volunteer]: VolunteerOrders,
  [Division.WorkingHoliday]: WorkingHolidayOrders,
  [Division.FIT]: [],
  [Division.Getaways]: GetawaysOrders,
};

type OrderType = {
  id: string;
  order: number;
  mobileOrder: number;
  children?: Array<{ id: string; order: number; mobileOrder: number }>;
};

const useDivisionMenuOrder = (trip?: Trip | null) => {
  const { isMobile } = useResponsive();
  const getOrder = useCallback(
    (routeId: string, subRouteId?: string) => {
      if (!trip?.division) return undefined;
      const currentMenuOrders = DivisionMenuOrders?.[trip.division] || [];
      const currentMenu = currentMenuOrders?.find(
        (each) => each?.id === routeId
      );
      if (subRouteId) {
        const currentSubMenu = currentMenu?.children?.find(
          (each) => each.id === subRouteId
        );
        return isMobile ? currentSubMenu?.mobileOrder : currentSubMenu?.order;
      } else {
        return isMobile ? currentMenu?.mobileOrder : currentMenu?.order;
      }
    },
    [isMobile, trip]
  );
  return { getOrder };
};

export default useDivisionMenuOrder;
